import React from "react";
import { Row, Col } from "antd";
import {
  InputItem,
  TextAreaItem,
  DatePickerItem,
} from "../../../components/forms/FormItems";
import { SettingsDataSelect } from "../../../components/forms/AutoCompleteFormItem";
import ClosedPreviousOrderItem from "../../../components/forms/ClosedPreviousOrderItem";
import CheckBoxItem from "../../../components/forms/CheckBoxItem";
import AutoCompleteFormItem from "../../../components/forms/AutoCompleteFormItem";
import { ClientsSelect } from "../../../components/forms/AutoCompleteFormItem";
import ReadOnlyItem from "../../../components/forms/ReadOnlyItem";
import { isAllowedFeature } from "../../organization/organizationSlice";

const NursingItems = ({
  hasEditorPermission,
  orderIsUsed,
  serviceType,
  getServiceTypeLabel,
  startDate,
  disabledFromDate,
  disabledDate,
  noEndDate,
  isTrom,
  filterContracts,
  filterClientFrameSymbols,
  filterClientTariffSymbols,
  activeOrder,
  changedValues,
  type,
  selectedClient,
  scopePrefix,
  selectedClientTariffSymbol,
  selectedRevahaAuthority,
}) => {
  const filters = activeOrder?.order_close_reason_id
    ? [{ active: true }, { id: activeOrder?.order_close_reason_id }]
    : [{ active: true }];
  const activeCloseReasonFilter = {
    $and: [
      {
        $or: filters,
      },
    ],
  };
  const is_revaha = selectedClient?.category?.revaha;
  const is_ministry_of_defence = selectedClient?.category?.ministry_of_defence;
  return (
    <Row>
      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
        {is_revaha && (
          <SettingsDataSelect
            name="client_frame_symbol_id"
            category="client"
            settingsdataName={"client_frame_symbol"}
            type="list"
            filterItems={filterClientFrameSymbols}
          />
        )}
        {is_revaha && (
          <SettingsDataSelect
            name="revaha_authority_id"
            category="order"
            settingsdataName={"system_tables/revaha_authorities"}
            type="list"
          />
        )}
        {selectedRevahaAuthority && (
          <ReadOnlyItem
            name="revaha_authority_contact"
            category="order"
            content={selectedRevahaAuthority.contact}
          />
        )}
        <AutoCompleteFormItem
          required={true}
          items={selectedClient ? selectedClient.service_types : []}
          name="service_type"
          category="order"
          disabled={orderIsUsed}
        />
        <InputItem
          disabled={orderIsUsed && !hasEditorPermission}
          required={true}
          number={true}
          itemLabel={getServiceTypeLabel()}
          name="max_hours"
          category="order"
          twoDigitsNumbers={true}
        />

        {serviceType &&
        serviceType.time_frame === 0 &&
        serviceType.recurring ? (
          <InputItem
            disabled={orderIsUsed && !hasEditorPermission}
            name="max_hours_per_month"
            category="order"
            number={true}
            twoDigitsNumbers={true}
            min={0.5}
          />
        ) : null}
        <DatePickerItem name="order_received_date" category="order" />
        <DatePickerItem
          required={true}
          name="effective_from"
          category="order"
          disabledDate={disabledFromDate}
        />
        {noEndDate === true ? null : (
          <DatePickerItem
            name="effective_to"
            category="order"
            required={true}
            disabledDate={disabledDate}
            disabled={!startDate}
          />
        )}
        {noEndDate === true ? null : (
          <SettingsDataSelect
            name="order_close_reason_id"
            category="order"
            settingsdataName={"system_tables/order_close_reason"}
            extraParams={{
              filter: activeCloseReasonFilter,
            }}
            required={true}
            type="list"
          />
        )}
        <div style={{ height: "6px" }} />
        {serviceType &&
        serviceType.time_frame === 0 &&
        !serviceType.recurring ? null : (
          <CheckBoxItem showLabel={true} name="no_end_date" category="order" />
        )}
        {isTrom && (
          <ClientsSelect
            required={true}
            extraParams={{
              scopePrefix: scopePrefix,
              filter: {
                social_security: {
                  $eq: true,
                },
              },
            }}
            name="trom_target_client_id"
            category="order"
          />
        )}
        {selectedClient && selectedClient.social_security && (
          <CheckBoxItem
            showLabel={true}
            name="report_as_trom"
            category="order"
          />
        )}
      </Col>
      <Col xs={24} sm={24} md={24} lg={12} xl={12}>
        {is_revaha && (
          <>
            <SettingsDataSelect
              name="client_tariff_symbol_id"
              category="order"
              settingsdataName={"client_tariff_symbol"}
              type="list"
              filterItems={filterClientTariffSymbols}
            />

            {selectedClientTariffSymbol && (
              <>
                <ReadOnlyItem
                  name="client_tariff_symbol_description"
                  category="order"
                  content={selectedClientTariffSymbol.description}
                />
                <ReadOnlyItem
                  name="client_tariff_symbol_service_type"
                  category="order"
                  content={selectedClientTariffSymbol.service_type}
                />
              </>
            )}
          </>
        )}
        <SettingsDataSelect
          name="contract_id"
          category="order"
          settingsdataName={"contracts"}
          disabled={!isAllowedFeature("contracts")}
          filterItems={filterContracts}
        />
        <InputItem
          name="reference_number"
          category="order"
          required={is_ministry_of_defence}
        />
        <InputItem
          name="commitment_number"
          category="order"
          required={selectedClient && selectedClient.holocast_fund}
        />
        <SettingsDataSelect
          name="benefit_level"
          category="order"
          benefitLevels={true}
          allowClear
          settingsdataName={"benefit_levels"}
          identfierId="name"
        />
        <InputItem
          step={0.5}
          name="adl_score"
          number={true}
          category="order"
          twoDigitsNumbers={true}
        />
        <TextAreaItem name="remarks" category="order" rows={4} />
        <CheckBoxItem showLabel={true} name="order_received" category="order" />
        {isTrom && (
          <CheckBoxItem showLabel={true} name="close_trom" category="order" />
        )}
        {type === "duplicate" ? (
          <ClosedPreviousOrderItem
            name="closed_previous_order_id"
            category="order"
            activeOrder={activeOrder}
            startDate={startDate}
          />
        ) : null}
        {changedValues["closed_previous_order_id"] && (
          <SettingsDataSelect
            name="previous_order_close_reason_id"
            category="order"
            settingsdataName={"system_tables/order_close_reason"}
            required={true}
          />
        )}
        {changedValues["closed_previous_order_id"] && (
          <CheckBoxItem
            showLabel={true}
            name="associate_previous_events"
            category="order"
          />
        )}
      </Col>
    </Row>
  );
};

export default NursingItems;
